import { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { useGetInverters } from "api";
import { AppLayout } from "components/layouts";
import {
  EarningsPage,
  ForecastPage,
  InverterPage,
  LoadingPage,
  NotificationsPage,
  PricesPage,
  RecordsPage,
  RelayPage,
  StatisticsPage,
} from "routes";
import {
  ANY_OTHER,
  EARNINGS,
  RECORDS,
  DEFAULT,
  STATISTICS,
  FORECAST,
  INVERTER,
  NOTIFICATIONS,
  PRICES,
  RELAY,
} from "routes/consts";
import { getSelectedPowerPlant, useAppSelector } from "store";

export const PrivateRoutes = () => {
  const selectedPowerPlant = useAppSelector(getSelectedPowerPlant);
  const { data: inverters } = useGetInverters();
  const hasInverters = (inverters?.length ?? 0) > 0;

  return (
    <Suspense fallback={<LoadingPage />}>
      <Routes>
        <Route path={DEFAULT} element={<AppLayout />}>
          <Route path={FORECAST} element={<ForecastPage />} />
          <Route path={RECORDS} element={<RecordsPage />} />
          <Route path={STATISTICS} element={<StatisticsPage />} />
          <Route path={NOTIFICATIONS} element={<NotificationsPage />} />
          {selectedPowerPlant?.showMarketPrices && (
            <>
              <Route path={PRICES} element={<PricesPage />} />
              <Route path={EARNINGS} element={<EarningsPage />} />
            </>
          )}
          {selectedPowerPlant?.relayChannelCount && (
            <Route path={RELAY} element={<RelayPage />} />
          )}
          {hasInverters && (
            <Route path={INVERTER} element={<InverterPage />} />
          )}
        </Route>
        <Route path={ANY_OTHER} element={<Navigate to={DEFAULT} replace />} />
      </Routes>
    </Suspense>
  );
};
